import { blank as api } from './blank'
export const addTagTypes = ['meshing', 'demo', 'max'] as const
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      saveNote: build.mutation<SaveNoteApiResponse, SaveNoteApiArg>({
        query: (queryArg) => ({
          url: `/note`,
          method: 'POST',
          body: queryArg.saveNoteRequest,
        }),
        invalidatesTags: ['meshing'],
      }),
      getNoteMetadata: build.query<
        GetNoteMetadataApiResponse,
        GetNoteMetadataApiArg
      >({
        query: () => ({ url: `/noteMetadata` }),
        providesTags: ['meshing'],
      }),
      getLiveDx: build.mutation<GetLiveDxApiResponse, GetLiveDxApiArg>({
        query: (queryArg) => ({
          url: `/liveDx`,
          method: 'POST',
          body: queryArg.getLiveDxQuery,
        }),
        invalidatesTags: ['meshing'],
      }),
      postScribeNoteMeshed: build.mutation<
        PostScribeNoteMeshedApiResponse,
        PostScribeNoteMeshedApiArg
      >({
        query: (queryArg) => ({
          url: `/meshScribeNote`,
          method: 'POST',
          body: queryArg.meshScribeNoteRequest,
        }),
        invalidatesTags: ['meshing'],
      }),
      getUserStyle: build.query<GetUserStyleApiResponse, GetUserStyleApiArg>({
        query: () => ({ url: `/userStyle` }),
        providesTags: ['meshing'],
      }),
      saveUserStyle: build.mutation<
        SaveUserStyleApiResponse,
        SaveUserStyleApiArg
      >({
        query: (queryArg) => ({
          url: `/userStyle`,
          method: 'POST',
          body: queryArg.userStylePreferencesPayload,
        }),
        invalidatesTags: ['meshing'],
      }),
      resetDemoDatabase: build.mutation<
        ResetDemoDatabaseApiResponse,
        ResetDemoDatabaseApiArg
      >({
        query: () => ({ url: `/demo/reset`, method: 'POST' }),
        invalidatesTags: ['demo'],
      }),
      resetDemoDatabaseForService: build.mutation<
        ResetDemoDatabaseForServiceApiResponse,
        ResetDemoDatabaseForServiceApiArg
      >({
        query: () => ({ url: `/demo/service-reset`, method: 'POST' }),
        invalidatesTags: ['demo'],
      }),
      healthcheck: build.query<HealthcheckApiResponse, HealthcheckApiArg>({
        query: () => ({ url: `/max/healthcheck` }),
        providesTags: ['max'],
      }),
      updateNote: build.mutation<UpdateNoteApiResponse, UpdateNoteApiArg>({
        query: (queryArg) => ({
          url: `/max/updateNote`,
          method: 'POST',
          body: queryArg.updateNoteRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      updateNoteBlock: build.mutation<
        UpdateNoteBlockApiResponse,
        UpdateNoteBlockApiArg
      >({
        query: (queryArg) => ({
          url: `/max/updateNoteBlock`,
          method: 'POST',
          body: queryArg.updateNoteBlockRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      filterEvidence: build.mutation<
        FilterEvidenceApiResponse,
        FilterEvidenceApiArg
      >({
        query: (queryArg) => ({
          url: `/max/filterEvidence`,
          method: 'POST',
          body: queryArg.filterEvidenceRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      filterConditions: build.mutation<
        FilterConditionsApiResponse,
        FilterConditionsApiArg
      >({
        query: (queryArg) => ({
          url: `/max/filterConditions`,
          method: 'POST',
          body: queryArg.filterConditionsRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      convertPractitionerNote: build.mutation<
        ConvertPractitionerNoteApiResponse,
        ConvertPractitionerNoteApiArg
      >({
        query: (queryArg) => ({
          url: `/max/convertPractitionerNote`,
          method: 'POST',
          body: queryArg.convertPractitionerNoteRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      getNoteHistory: build.query<
        GetNoteHistoryApiResponse,
        GetNoteHistoryApiArg
      >({
        query: (queryArg) => ({
          url: `/max/noteHistory`,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
          params: {
            practitionerNoteId: queryArg.practitionerNoteId,
            patientId: queryArg.patientId,
            encounterId: queryArg.encounterId,
            regardPatientId: queryArg.regardPatientId,
          },
        }),
        providesTags: ['max'],
      }),
      generateNote: build.mutation<GenerateNoteApiResponse, GenerateNoteApiArg>(
        {
          query: (queryArg) => ({
            url: `/max/generateNote`,
            method: 'POST',
            body: queryArg.generateNoteRequest,
            cookies: {
              ht_session: queryArg.htSession,
              automed_oauth_subject: queryArg.automedOauthSubject,
            },
          }),
          invalidatesTags: ['max'],
        },
      ),
      generateNoteStream: build.mutation<
        GenerateNoteStreamApiResponse,
        GenerateNoteStreamApiArg
      >({
        query: (queryArg) => ({
          url: `/max/generateNoteStream`,
          method: 'POST',
          body: queryArg.generateNoteRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      maxUpdateNote: build.mutation<
        MaxUpdateNoteApiResponse,
        MaxUpdateNoteApiArg
      >({
        query: (queryArg) => ({
          url: `/max/maxUpdateNote`,
          method: 'POST',
          body: queryArg.maxUpdateNoteRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      maxUpdateNoteStream: build.mutation<
        MaxUpdateNoteStreamApiResponse,
        MaxUpdateNoteStreamApiArg
      >({
        query: (queryArg) => ({
          url: `/max/maxUpdateNoteStream`,
          method: 'POST',
          body: queryArg.maxUpdateNoteRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      maxGenerateFromBaseNote: build.mutation<
        MaxGenerateFromBaseNoteApiResponse,
        MaxGenerateFromBaseNoteApiArg
      >({
        query: (queryArg) => ({
          url: `/max/maxGenerateFromBaseNote`,
          method: 'POST',
          body: queryArg.maxGenerateFromBaseNoteRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      maxGenerateFromBaseNoteStream: build.mutation<
        MaxGenerateFromBaseNoteStreamApiResponse,
        MaxGenerateFromBaseNoteStreamApiArg
      >({
        query: (queryArg) => ({
          url: `/max/maxGenerateFromBaseNoteStream`,
          method: 'POST',
          body: queryArg.maxGenerateFromBaseNoteRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      startChat: build.mutation<StartChatApiResponse, StartChatApiArg>({
        query: (queryArg) => ({
          url: `/max/startChat`,
          method: 'POST',
          body: queryArg.startChatRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      addChatUserPrompt: build.mutation<
        AddChatUserPromptApiResponse,
        AddChatUserPromptApiArg
      >({
        query: (queryArg) => ({
          url: `/max/addChatUserPrompt`,
          method: 'POST',
          body: queryArg.addChatUserPromptRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      categorizeIntent: build.mutation<
        CategorizeIntentApiResponse,
        CategorizeIntentApiArg
      >({
        query: (queryArg) => ({
          url: `/max/categorizeIntent`,
          method: 'POST',
          body: queryArg.categorizeIntentRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      maxChatPatientData: build.mutation<
        MaxChatPatientDataApiResponse,
        MaxChatPatientDataApiArg
      >({
        query: (queryArg) => ({
          url: `/max/maxChatPatientData`,
          method: 'POST',
          body: queryArg.maxChatPatientDataRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      sendToProblemList: build.mutation<
        SendToProblemListApiResponse,
        SendToProblemListApiArg
      >({
        query: (queryArg) => ({
          url: `/max/sendToProblemList`,
          method: 'POST',
          body: queryArg.sendToProblemListRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      deriveNotePreferences: build.mutation<
        DeriveNotePreferencesApiResponse,
        DeriveNotePreferencesApiArg
      >({
        query: (queryArg) => ({
          url: `/max/derive-note-preferences`,
          method: 'POST',
          body: queryArg.deriveNotePreferencesRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      deriveNoteStructure: build.mutation<
        DeriveNoteStructureApiResponse,
        DeriveNoteStructureApiArg
      >({
        query: (queryArg) => ({
          url: `/max/derive-note-structure`,
          method: 'POST',
          body: queryArg.deriveNoteStructureRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      validateContentDirectives: build.mutation<
        ValidateContentDirectivesApiResponse,
        ValidateContentDirectivesApiArg
      >({
        query: (queryArg) => ({
          url: `/max/validate-content-directives`,
          method: 'POST',
          body: queryArg.validateContentDirectivesRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      validateAdminOverrides: build.mutation<
        ValidateAdminOverridesApiResponse,
        ValidateAdminOverridesApiArg
      >({
        query: (queryArg) => ({
          url: `/max/validate-admin-overrides`,
          method: 'POST',
          body: queryArg.validateAdminOverridesRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      validateUserDirectives: build.mutation<
        ValidateUserDirectivesApiResponse,
        ValidateUserDirectivesApiArg
      >({
        query: (queryArg) => ({
          url: `/max/validate-user-directives`,
          method: 'POST',
          body: queryArg.validateUserDirectivesRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      styleNoteText: build.mutation<
        StyleNoteTextApiResponse,
        StyleNoteTextApiArg
      >({
        query: (queryArg) => ({
          url: `/max/style-note-text`,
          method: 'POST',
          body: queryArg.styleNoteTextRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      previewStructure: build.mutation<
        PreviewStructureApiResponse,
        PreviewStructureApiArg
      >({
        query: (queryArg) => ({
          url: `/max/preview-structure`,
          method: 'POST',
          body: queryArg.previewStructureRequest,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
        }),
        invalidatesTags: ['max'],
      }),
      getPrevisitConditions: build.query<
        GetPrevisitConditionsApiResponse,
        GetPrevisitConditionsApiArg
      >({
        query: (queryArg) => ({
          url: `/max/previsitConditions`,
          cookies: {
            ht_session: queryArg.htSession,
            automed_oauth_subject: queryArg.automedOauthSubject,
          },
          params: {
            patientId: queryArg.patientId,
            encodedPatientId: queryArg.encodedPatientId,
          },
        }),
        providesTags: ['max'],
      }),
    }),
    overrideExisting: false,
  })
export { injectedRtkApi as meshingApi }
export type SaveNoteApiResponse =
  /** status 200 Successful Response */ NoteResponse
export type SaveNoteApiArg = {
  saveNoteRequest: SaveNoteRequest
}
export type GetNoteMetadataApiResponse =
  /** status 200 Successful Response */ GetNoteMetadataResponse
export type GetNoteMetadataApiArg = void
export type GetLiveDxApiResponse =
  /** status 200 Successful Response */ NoteBlock
export type GetLiveDxApiArg = {
  getLiveDxQuery: GetLiveDxQuery
}
export type PostScribeNoteMeshedApiResponse =
  /** status 200 Successful Response */ NoteResponse
export type PostScribeNoteMeshedApiArg = {
  meshScribeNoteRequest: MeshScribeNoteRequest
}
export type GetUserStyleApiResponse =
  /** status 200 Successful Response */ UserStylePreferencesPayload
export type GetUserStyleApiArg = void
export type SaveUserStyleApiResponse = /** status 200 Successful Response */ any
export type SaveUserStyleApiArg = {
  userStylePreferencesPayload: UserStylePreferencesPayload
}
export type ResetDemoDatabaseApiResponse =
  /** status 200 Successful Response */ {
    [key: string]: string
  }
export type ResetDemoDatabaseApiArg = void
export type ResetDemoDatabaseForServiceApiResponse =
  /** status 200 Successful Response */ {
    [key: string]: string
  }
export type ResetDemoDatabaseForServiceApiArg = void
export type HealthcheckApiResponse =
  /** status 200 Successful Response */ HealthCheckResponse
export type HealthcheckApiArg = void
export type UpdateNoteApiResponse =
  /** status 200 Successful Response */ UpdateNoteResponse
export type UpdateNoteApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  updateNoteRequest: UpdateNoteRequest
}
export type UpdateNoteBlockApiResponse =
  /** status 200 Successful Response */ UpdateNoteBlockResponse
export type UpdateNoteBlockApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  updateNoteBlockRequest: UpdateNoteBlockRequest
}
export type FilterEvidenceApiResponse =
  /** status 200 Successful Response */ FilterEvidenceResponse
export type FilterEvidenceApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  filterEvidenceRequest: FilterEvidenceRequest
}
export type FilterConditionsApiResponse =
  /** status 200 Successful Response */ FilterConditionsResponse
export type FilterConditionsApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  filterConditionsRequest: FilterConditionsRequest
}
export type ConvertPractitionerNoteApiResponse =
  /** status 200 Successful Response */ ConvertPractitionerNoteResponse
export type ConvertPractitionerNoteApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  convertPractitionerNoteRequest: ConvertPractitionerNoteRequest
}
export type GetNoteHistoryApiResponse =
  /** status 200 Successful Response */ NoteHistoryResponse
export type GetNoteHistoryApiArg = {
  practitionerNoteId: string
  patientId: string
  encounterId: string
  regardPatientId?: string | null
  htSession?: string | null
  automedOauthSubject?: string | null
}
export type GenerateNoteApiResponse =
  /** status 200 Successful Response */ GeneratedNoteResponse
export type GenerateNoteApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  generateNoteRequest: GenerateNoteRequest
}
export type GenerateNoteStreamApiResponse =
  /** status 200 Server-sent event stream.  Emits 'token' events with partial note content while the LLM generates, then a single 'complete' event with the fully validated GeneratedNoteResponse after all validation steps finish. */ string
export type GenerateNoteStreamApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  generateNoteRequest: GenerateNoteRequest
}
export type MaxUpdateNoteApiResponse =
  /** status 200 Successful Response */ GeneratedNoteResponse
export type MaxUpdateNoteApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  maxUpdateNoteRequest: MaxUpdateNoteRequest
}
export type MaxUpdateNoteStreamApiResponse =
  /** status 200 Server-sent event stream.  Emits 'token' events with partial note content while the LLM generates, then a single 'complete' event with the fully validated GeneratedNoteResponse after all validation steps finish. */ string
export type MaxUpdateNoteStreamApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  maxUpdateNoteRequest: MaxUpdateNoteRequest
}
export type MaxGenerateFromBaseNoteApiResponse =
  /** status 200 Successful Response */ GeneratedNoteResponse
export type MaxGenerateFromBaseNoteApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  maxGenerateFromBaseNoteRequest: MaxGenerateFromBaseNoteRequest
}
export type MaxGenerateFromBaseNoteStreamApiResponse =
  /** status 200 Server-sent event stream.  Emits 'token' events with partial note content while the LLM generates, then a single 'complete' event with the fully validated GeneratedNoteResponse after all validation steps finish. */ string
export type MaxGenerateFromBaseNoteStreamApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  maxGenerateFromBaseNoteRequest: MaxGenerateFromBaseNoteRequest
}
export type StartChatApiResponse =
  /** status 200 Successful Response */ StartChatResponse
export type StartChatApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  startChatRequest: StartChatRequest
}
export type AddChatUserPromptApiResponse =
  /** status 200 Successful Response */ any
export type AddChatUserPromptApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  addChatUserPromptRequest: AddChatUserPromptRequest
}
export type CategorizeIntentApiResponse =
  /** status 200 Successful Response */ CategorizeIntentResponse
export type CategorizeIntentApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  categorizeIntentRequest: CategorizeIntentRequest
}
export type MaxChatPatientDataApiResponse =
  /** status 200 Successful Response */ MaxChatPatientDataResponse
export type MaxChatPatientDataApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  maxChatPatientDataRequest: MaxChatPatientDataRequest
}
export type SendToProblemListApiResponse =
  /** status 201 Successful Response */ SendToProblemListResponse
export type SendToProblemListApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  sendToProblemListRequest: SendToProblemListRequest
}
export type DeriveNotePreferencesApiResponse =
  /** status 200 Successful Response */ DeriveNotePreferencesResponse
export type DeriveNotePreferencesApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  deriveNotePreferencesRequest: DeriveNotePreferencesRequest
}
export type DeriveNoteStructureApiResponse =
  /** status 200 Successful Response */ DeriveNoteStructureResponse
export type DeriveNoteStructureApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  deriveNoteStructureRequest: DeriveNoteStructureRequest
}
export type ValidateContentDirectivesApiResponse =
  /** status 200 Successful Response */ ValidateContentDirectivesResponse
export type ValidateContentDirectivesApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  validateContentDirectivesRequest: ValidateContentDirectivesRequest
}
export type ValidateAdminOverridesApiResponse =
  /** status 200 Successful Response */ ValidateAdminOverridesResponse
export type ValidateAdminOverridesApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  validateAdminOverridesRequest: ValidateAdminOverridesRequest
}
export type ValidateUserDirectivesApiResponse =
  /** status 200 Successful Response */ ValidateUserDirectivesResponse
export type ValidateUserDirectivesApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  validateUserDirectivesRequest: ValidateUserDirectivesRequest
}
export type StyleNoteTextApiResponse =
  /** status 200 Successful Response */ StyleNoteTextResponse
export type StyleNoteTextApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  styleNoteTextRequest: StyleNoteTextRequest
}
export type PreviewStructureApiResponse =
  /** status 200 Successful Response */ PreviewStructureResponse
export type PreviewStructureApiArg = {
  htSession?: string | null
  automedOauthSubject?: string | null
  previewStructureRequest: PreviewStructureRequest
}
export type GetPrevisitConditionsApiResponse =
  /** status 200 Successful Response */ PrevisitConditionsResponse
export type GetPrevisitConditionsApiArg = {
  patientId: string
  encodedPatientId: string
  htSession?: string | null
  automedOauthSubject?: string | null
}
export type NoteStatus = 'draft' | 'final' | 'base'
export type NoteType = 'historyPhysical' | 'progress'
export type NoteSectionType =
  | 'assessmentPlan'
  | 'twentyFourHourCourse'
  | 'subjective'
  | 'chiefComplaint'
  | 'historyOfPresentIllness'
  | 'physicalExam'
export type NoteSubsectionType =
  | 'conditionSubsection'
  | 'shelfSubsection'
  | 'footerSubsection'
  | 'oneLinerSubsection'
  | 'genericSubsection'
export type NoteBlockType = 'freetextBlock'
export type NoteLineType = 'freetextLine'
export type NoteLineSource =
  | 'baseNote'
  | 'regardAdded'
  | 'regardUpdated'
  | 'scribeAdded'
  | 'scribeUpdated'
  | 'userAdded'
export type AssociatedConditionDecoration = {
  /** type of this decoration */
  noteDecorationType: 'associatedCondition'
  /** the condition name for this decoration */
  condition: string
}
export type ConditionNameUnderlineDecoration = {
  /** type of this decoration */
  noteDecorationType: 'conditionNameUnderline'
  /** the Regard supported condition module that this decoration represents */
  conditionModule: string
  /** the text of a note line that should be underlined as the condition module */
  lineText: string
}
export type NumberedConditionHeaderDecoration = {
  /** type of this decoration */
  noteDecorationType: 'numberedConditionHeader'
}
export type ObservationInterpretation =
  | 'critical'
  | 'criticallyHigh'
  | 'criticallyLow'
  | 'high'
  | 'low'
  | 'normal'
  | 'abnormal'
export type ObservationInterpretationDecoration = {
  /** type of this decoration */
  noteDecorationType: 'observationInterpretation'
  /** the observation interpretation for this decoration */
  observationInterpretation: ObservationInterpretation
}
export type NoteDecoration =
  | ({
      noteDecorationType: 'associatedCondition'
    } & AssociatedConditionDecoration)
  | ({
      noteDecorationType: 'conditionNameUnderline'
    } & ConditionNameUnderlineDecoration)
  | ({
      noteDecorationType: 'numberedConditionHeader'
    } & NumberedConditionHeaderDecoration)
  | ({
      noteDecorationType: 'observationInterpretation'
    } & ObservationInterpretationDecoration)
export type MesherConcept = {
  /** The clinical concept's unique identifier. */
  id: string
  /** The type of clinical concept. */
  type: string
  /** The label of the clinical concept. */
  label: string
}
export type MesherIdentifiedConcept = {
  /** The concept that was mentioned. */
  concept: MesherConcept
  /** The text that was matched in the source document. */
  matchedText: string
  /** The location of the matched text in the source document. */
  span: [number, number]
  /** Whether the condition is supported in regard dxs */
  regardSupported?: boolean
}
export type NoteLine = {
  /** type of this line */
  noteLineType: NoteLineType
  /** the id of this line */
  id: string
  /** datetime that this line was created */
  createdDatetime: string
  /** user editable html string content of this line */
  html: string
  /** the source type of this line */
  source: NoteLineSource
  /** the decorations on this line */
  decorations: NoteDecoration[]
  /** whether this line has been dismissed */
  dismissed: boolean
  /** whether this line is in the note */
  inNote: boolean
  /** whether this line is a condition header */
  conditionHeader: boolean
  /** condition concepts identified for this line */
  conditionConcepts?: MesherIdentifiedConcept[]
  /** list of regard dx bullet texts the line is composed of (either directly or that have meshed into it) */
  unstyledBulletTexts?: string[]
}
export type NoteBlock = {
  /** type of this note block */
  noteBlockType: NoteBlockType
  /** id of this note block */
  id: string
  /** the note lines in this note block, in the order of how they appear */
  lines: NoteLine[]
  /** whether this block has been dismissed */
  dismissed: boolean
}
export type NoteSubsection = {
  /** type of this subsection */
  noteSubsectionType: NoteSubsectionType
  /** the id of this subsection */
  id: string
  /** the note blocks in this note subsection, in the order of how they appear */
  blocks: NoteBlock[]
}
export type NoteSection = {
  /** type of this section */
  noteSectionType: NoteSectionType
  /** the id of this section */
  id: string
  /** the subsections in this section, in the order of how they appear */
  subsections: NoteSubsection[]
}
export type NotePayload = {
  /** type of this note */
  noteType: NoteType
  /** the note sections in this Note, in the order of how they appear */
  sections: NoteSection[]
  /** the id of this Note */
  id: string
}
export type RegardConditionSourceBullet = {
  /** unique identifier for this bullet */
  id: string
  /** the text content of the bullet */
  text: string
  /** decorations including AssociatedConditionDecoration and ObservationInterpretationDecoration */
  associatedDecorations?: NoteDecoration[]
  /** the condition module this bullet is associated with */
  module: string
}
export type Note = {
  id: number
  version: string
  userId: string
  status: NoteStatus
  encounterId: string
  practitionerNoteId: string
  previousNoteId: number | null
  previousNoteVersion: string | null
  adminSave: boolean
  basePractitionerNoteContentHash: string
  notePayload: NotePayload
  sources: string[]
  regardConditionSourceBullets: RegardConditionSourceBullet[]
}
export type LineVersion = {
  version: string
  line: NoteLine
}
export type LineVersionHistory = {
  lineVersions: {
    [key: string]: LineVersion[]
  }
  currentTimestamp: string
}
export type NoteVersionHistory = {
  lineVersionHistory: LineVersionHistory
  /** A mapping of line ids to the most recent user attributed line version, if one such exists for the line. */
  mostRecentUserAttributedLineVersions: {
    [key: string]: LineVersion
  }
}
export type NoteResponse = {
  note: Note
  noteVersionHistory?: NoteVersionHistory | null
  conditionsToFilteredBulletIds?: {
    [key: string]: string[]
  } | null
  conditionsToSecondaryEvidenceBulletIds?: {
    [key: string]: string[]
  } | null
  baseNoteHasUpdates?: boolean
  generationId?: string
  generatedPayloadHash?: string | null
}
export type ValidationError = {
  loc: (string | number)[]
  msg: string
  type: string
  input?: any
  ctx?: object
}
export type HttpValidationError = {
  detail?: ValidationError[]
}
export type SaveNoteRequest = {
  id: number
  notePayload: NotePayload
  status: NoteStatus
}
export type NoteDecorationType =
  | 'conditionNameUnderline'
  | 'observationInterpretation'
  | 'numberedConditionHeader'
  | 'associatedCondition'
export type GetNoteMetadataResponse = {
  sectionNameMap: {
    [key: string]: string
  }
  subsectionCanMatchConditionNames: {
    [key: string]: boolean
  }
  subsectionCanShelveBlocks: {
    [key: string]: boolean
  }
  subsectionNameMap: {
    [key: string]: string
  }
  validSubsectionsForNote: {
    [key: string]: NoteSectionType[]
  }
  validBlocksForSubsection: {
    [key: string]: NoteBlockType[]
  }
  validDecorationsForLine: {
    [key: string]: NoteDecorationType[]
  }
  validLinesForBlock: {
    [key: string]: NoteLineType[]
  }
  validSubsectionsForSection: {
    [key: string]: NoteSubsectionType[]
  }
}
export type GetLiveDxQuery = {
  noteId?: number | null
  practitionerNoteId?: string | null
  patientId: string
  regardPatientId?: string | null
  condition: string
  noteBlock: NoteBlock
}
export type MeshScribeNoteRequest = {
  noteId: number
  scribeNoteRecordId: string
  patientId: string
  notePayload: NotePayload
  transcriptionDate?: string | null
}
export type ConditionTitlePrefix =
  | 'hashtag'
  | 'number'
  | 'none'
  | 'inconclusive'
export type ConditionTitleBold = 'bold' | 'not bold' | 'inconclusive'
export type ConditionTitleItalics = 'italics' | 'not italics' | 'inconclusive'
export type ConditionTitleCapitalization =
  | 'first letter'
  | 'title case'
  | 'all letters'
  | 'none'
  | 'inconclusive'
export type EvidenceLinePrefix =
  | 'space'
  | 'dash'
  | 'dash and space'
  | 'none'
  | 'inconclusive'
export type EvidenceLineCapitalization = 'capital' | 'small' | 'inconclusive'
export type DateFormat =
  | 'MM/dd/yyyy'
  | 'MM/dd/yy'
  | 'MM/dd'
  | 'MM-dd'
  | 'MM-dd-yyyy'
  | 'MM-dd-yy'
  | 'M/d/yyyy'
  | 'M/d/yy'
  | 'M/d'
  | 'M-d'
  | 'M-d-yyyy'
  | 'M-d-yy'
  | 'inconclusive'
export type MedsDateInclusion = 'include' | 'exclude' | 'inconclusive'
export type LabsDateInclusion = 'include' | 'exclude' | 'inconclusive'
export type VitalsDateInclusion = 'include' | 'exclude' | 'inconclusive'
export type VitalsTimeInclusion = 'include' | 'exclude' | 'inconclusive'
export type UserStylePreferencesPayload = {
  /** Which prefix, if any, should be used at the beginning of the condition title? */
  conditionTitlePrefix: ConditionTitlePrefix
  /** Should the condition title be bolded? */
  conditionTitleBold: ConditionTitleBold
  /** Should the condition title be italicized? */
  conditionTitleItalics: ConditionTitleItalics
  /** How should condition titles be capitalized? */
  conditionTitleCapitalization: ConditionTitleCapitalization
  /** What prefix should be used at the beginning of each evidence line? */
  evidenceLinePrefix: EvidenceLinePrefix
  /** How should the first letter of an evidence line be capitalized? */
  evidenceLineCapitalization: EvidenceLineCapitalization
  /** Which format should be used for all dates? */
  dateFormat: DateFormat
  /** Should dates in medication evidence lines be retained or removed? */
  medsDateInclusion: MedsDateInclusion
  /** Should dates in lab evidence lines be retained or removed? */
  labsDateInclusion: LabsDateInclusion
  /** Should dates in vitals evidence lines be retained or removed? */
  vitalsDateInclusion: VitalsDateInclusion
  /** Should time information in vitals evidence lines be retained or removed? */
  vitalsTimeInclusion: VitalsTimeInclusion
}
export type HealthCheckResponse = {
  activeThreadCount: number
  timestamp: string
  version: string
}
export type UpdateNoteResponse = {
  notePayload: NotePayload
  conditionsToFilteredBulletIds: {
    [key: string]: string[]
  }
  conditionsToSecondaryEvidenceBulletIds: {
    [key: string]: string[]
  }
  regardConditionSourceBullets: RegardConditionSourceBullet[]
}
export type BlockDismissal = {
  blockId: string
  noteVersion: string
  encounterId: string
  noteId: number
  userId: string
  adminSave: boolean
  conditionModules: string[]
}
export type LineDismissal = {
  lineId: string
  noteVersion: string
  encounterId: string
  lineContentMd: string
  noteId: number
  userId: string
  adminSave: boolean
  linkedConditionModules: string[]
}
export type UpdateNoteRequest = {
  note: NotePayload
  patientId: string
  encounterId: string
  practitionerNoteId: string
  blockDismissals: BlockDismissal[]
  lineDismissals: LineDismissal[]
  userStyle: UserStylePreferencesPayload
  fetchTimestamp?: string | null
}
export type UpdateNoteBlockResponse = {
  noteBlock: NoteBlock
}
export type UpdateNoteBlockRequest = {
  noteBlock: NoteBlock
  patientId: string
  practitionerNoteId: string
  condition: string
  userStyle: UserStylePreferencesPayload
}
export type FilterEvidenceResponse = {
  evidenceToFilter: {
    [key: string]: string[]
  }
}
export type ConditionInfo = {
  conditionTitle: string
  evidenceLines: string[]
}
export type FilterEvidenceRequest = {
  baseNote: string
  patientId: string
  newEvidence: {
    [key: string]: ConditionInfo
  }
}
export type FilterConditionsResponse = {
  conditionsToFilter: string[]
}
export type FilterConditionsRequest = {
  baseNote: string
  patientId: string
  newConditionsAndEvidence: {
    [key: string]: ConditionInfo
  }
}
export type ConvertPractitionerNoteResponse = {
  notePayload: NotePayload
}
export type ConvertPractitionerNoteRequest = {
  noteText: string
  patientId: string
}
export type NoteHistoryResponse = {
  notes: Note[]
}
export type SpanStatus = 'NEW' | 'UPDATED' | 'EXISTING'
export type SpanType = 'CONDITION' | 'CITATION'
export type ConditionSource = 'REGARD_DX' | 'PROBLEM_LIST' | 'LLM_ADDED'
export type DiagnosisBasis = 'mention' | 'criteria' | 'both' | 'none'
export type Span = {
  id?: string
  start: number
  end: number
  updatedAt: string
  sourceIds?: string[] | null
  status: SpanStatus
  type: SpanType
  originalText?: string | null
  codes?: {
    [key: string]: string[]
  } | null
  codeSources?: {
    [key: string]: ConditionSource
  } | null
  diagnosisBasis?: DiagnosisBasis
  conditionSource?: ConditionSource | null
}
export type ChangeSummaryItem = {
  text: string
  anchorSubstring?: string | null
}
export type ChangeSummary = {
  problemsAdded?: ChangeSummaryItem[]
  problemsRemoved?: ChangeSummaryItem[]
  medicationChanges?: ChangeSummaryItem[]
  newResults?: ChangeSummaryItem[]
  disposition?: ChangeSummaryItem[]
  general?: ChangeSummaryItem[]
}
export type CitationSourceType =
  | 'dx_evidence'
  | 'clinical_note'
  | 'demographic'
  | 'problem'
  | 'hospital_problem'
  | 'diagnostic_report'
  | 'encounter'
  | 'lab'
  | 'panel'
  | 'vital'
  | 'medication'
  | 'procedure'
  | 'quant_observation'
  | 'qual_observation'
  | 'scribe_note'
export type MesherBullet = {
  id: string
  bulletText: string
  bulletMetadata: {
    [key: string]: string
  }
  bulletTags?: string[]
  isUnraveledMedBullet?: boolean
}
export type PractitionerNoteStatus =
  | 'note_status.amended'
  | 'note_status.entered-in-error'
  | 'note_status.final'
  | 'note_status.preliminary'
export type MaxPractitionerNote = {
  resourceType?: string | null
  id?: string | null
  sourceId?: string | null
  mappedAt?: string | null
  effectiveAt?: string | null
  encounterId?: string | null
  version?: string | null
  externalOrganization?: string | null
  content?: string | null
  practitionerCredentials?: string[] | null
  noteKinds?: string[] | null
  specialtyLabels?: string[] | null
  authorName?: string | null
  status?: PractitionerNoteStatus | null
  [key: string]: any
}
export type MaxDiagnosticReport = {
  resourceType?: string | null
  id?: string | null
  sourceId?: string | null
  mappedAt?: string | null
  effectiveAt?: string | null
  encounterId?: string | null
  version?: string | null
  externalOrganization?: string | null
  content?: string | null
  authorName?: string | null
  reportType?: string | null
  [key: string]: any
}
export type Period = {
  start?: string | null
  end?: string | null
}
export type MaxEncounter = {
  resourceType?: string | null
  id?: string | null
  sourceId?: string | null
  mappedAt?: string | null
  effectiveAt?: string | null
  encounterId?: string | null
  version?: string | null
  externalOrganization?: string | null
  status?: string | null
  period?: Period | null
  classType?: string | null
  [key: string]: any
}
export type Concept = {
  /** The clinical concept's unique identifier. */
  id: string
  /** The type of clinical concept. */
  type: string
  /** The label of the clinical concept. */
  label: string
  /** The scale of the clinical concept (e.g., 'Qn' for quantitative). Only applicable to observation concepts. */
  scale?: string | null
  /** The value_set concepts this concept belongs to. Only applicable to value concepts. */
  value_sets?: Concept[] | null
  /** Optional attributes attached directly to the concept definition. */
  attributes?: {
    [key: string]: any
  } | null
  [key: string]: any
}
export type Quantity = {
  /** The magnitude of the quantity. */
  magnitude: number | string
  /** The unit of the quantity. */
  unit: Concept | null
}
export type QuantityRange = {
  /** The lower bound of the quantity range. */
  low: number | string | null
  /** The upper bound of the quantity range. */
  high: number | string | null
  /** The unit of the quantity range limits. */
  unit: Concept | null
  /** Whether the lower bound is inclusive. */
  lower_inclusive: boolean
  /** Whether the upper bound is inclusive. */
  upper_inclusive: boolean
}
export type QuantityRatio = {
  /** The numerator of the ratio. */
  numerator: Quantity
  /** The denominator of the ratio. */
  denominator: Quantity
}
export type QuantObservationSummary = {
  label?: string | null
  value?: Quantity | QuantityRange | QuantityRatio | null
}
export type MaxQuantitativeObservation = {
  resourceType?: string | null
  id?: string | null
  sourceId?: string | null
  mappedAt?: string | null
  effectiveAt?: string | null
  encounterId?: string | null
  version?: string | null
  externalOrganization?: string | null
  observationSummaries?: QuantObservationSummary[] | null
  [key: string]: any
}
export type MaxQualitativeObservation = {
  resourceType?: string | null
  id?: string | null
  sourceId?: string | null
  mappedAt?: string | null
  effectiveAt?: string | null
  encounterId?: string | null
  version?: string | null
  externalOrganization?: string | null
  label?: string | null
  values: {
    [key: string]: string[]
  }
  [key: string]: any
}
export type MaxMedicationRequest = {
  resourceType?: string | null
  id?: string | null
  sourceId?: string | null
  mappedAt?: string | null
  effectiveAt?: string | null
  encounterId?: string | null
  version?: string | null
  externalOrganization?: string | null
  medicationRequestId: string
  encounter?: {
    [key: string]: any
  } | null
  route?: {
    [key: string]: any
  } | null
  asNeeded?: boolean | null
  period: Period
  periodInterval?: string | null
  frequency?: number | null
  frequencyText?: string | null
  status: {
    [key: string]: any
  }
  medicationName: string
  medication?: {
    [key: string]: any
  } | null
  categories: {
    [key: string]: any
  }[]
  doseCount?: number | null
  maxDoseCount?: number | null
  dose?: Quantity | null
  doseRange?: QuantityRange | null
  doseDuration?: string | null
  maxDoseDuration?: string | null
  rate?: Quantity | null
  rateRange?: QuantityRange | null
  intent: {
    [key: string]: any
  }
  reported?: boolean | null
  priorMedicationRequest?: {
    [key: string]: any
  } | null
  authoredOn?: string | null
  [key: string]: any
}
export type MaxProcedure = {
  resourceType?: string | null
  id?: string | null
  sourceId?: string | null
  mappedAt?: string | null
  effectiveAt?: string | null
  encounterId?: string | null
  version?: string | null
  externalOrganization?: string | null
  concepts?: string[]
  status?: string | null
  [key: string]: any
}
export type ProblemListCondition = {
  id?: string | null
  displayName: string
  icd10Code?: string | null
  icd10Codes?: string[]
  recordedDate?: string | null
  slug?: string
}
export type CitationSource = {
  id: string
  type: CitationSourceType
  content:
    | string
    | MesherBullet
    | MaxPractitionerNote
    | MaxDiagnosticReport
    | MaxEncounter
    | MaxQuantitativeObservation
    | MaxQualitativeObservation
    | MaxMedicationRequest
    | MaxProcedure
    | ProblemListCondition
}
export type ExcludedCondition = {
  conditionModule: string
  contentMd: string
  spans: Span[]
  diagnosisBasis?: DiagnosisBasis
}
export type GeneratedNoteResponse = {
  contentMd: string
  spans: Span[]
  newContentSubstrings?: string[]
  changeSummary?: ChangeSummary
  excludedEvidence: {
    [key: string]: CitationSource[]
  }
  excludedConditions: ExcludedCondition[]
  citationSources: {
    [key: string]: CitationSource
  }
  snapshotVersion: string | null
}
export type NoteType2 =
  | 'progress-note'
  | 'history-physical'
  | 'discharge-summary'
  | 'attestation'
  | 'other'
  | 'consult'
  | 'procedure-note'
  | 'op-note'
  | 'annual-wellness-visit'
  | 'sick-visit'
  | 'follow-up'
  | 'icu-hp'
  | 'icu-progress-note'
  | 'hospital-course-standalone'
  | 'icu-step-down-transfer'
  | 'sign-out'
  | 'unknown'
export type DismissedConditionInfo = {
  conditionModule: string
  conditionHeader: string
  lastModifiedById: string
  lastModifiedByName: string
  dismissedAt: string
}
export type Section = {
  title: string
  description: string
  sectionType?: string | null
  systemDefaults?: string | null
  recognitionContext?: string | null
  adminOverrides?: string[]
}
export type NoteStructurePreferences = {
  sections?: Section[]
  freeTextDirectives?: string[]
}
export type Specialty =
  | 'hospital_medicine'
  | 'critical_care'
  | 'cardiology'
  | 'case_management'
  | 'cardiothoracic_surgery'
  | 'general_surgery'
  | 'hospice_palliative_medicine'
  | 'infectious_disease'
  | 'oncology'
  | 'orthopedic_surgery'
  | 'pulmonology'
  | 'emergency_medicine'
  | 'nephrology'
  | 'neurology'
export type GenerateNoteRequest = {
  patientId: string
  encodedPatientId: string
  encounterId: string
  baseNoteContentMd: string
  noteType: NoteType2
  dismissedContent?: Span[]
  dismissedConditions?: DismissedConditionInfo[]
  baseNoteId?: string | null
  legacyDismissedContent?: string[] | null
  fetchTimestamp?: string | null
  userPrompt?: string | null
  noteStructurePreferences?: NoteStructurePreferences | null
  primarySpecialty?: Specialty | null
  /** Optional chief complaint for outpatient sick-visit and follow-up notes. */
  chiefComplaint?: string | null
  /** Condition modules explicitly selected by the clinician in the previsit flow. When provided, only these conditions are included in the note. */
  selectedConditionModules?: string[] | null
}
export type MaxUpdateNoteRequest = {
  patientId: string
  encodedPatientId: string
  encounterId: string
  baseNoteContentMd: string
  noteType: NoteType2
  dismissedContent?: Span[]
  dismissedConditions?: DismissedConditionInfo[]
  baseNoteId?: string | null
  legacyDismissedContent?: string[] | null
  existingSpans?: Span[]
  generationTimestamp?: string | null
  generationSnapshotVersion?: string | null
  fetchTimestamp?: string | null
  userPrompt?: string | null
  noteStructurePreferences?: NoteStructurePreferences | null
  physicianEditSegments?: string[]
  settingsChanged?: boolean
  primarySpecialty?: Specialty | null
}
export type MaxGenerateFromBaseNoteRequest = {
  patientId: string
  encodedPatientId: string
  encounterId: string
  baseNoteContentMd: string
  noteType: NoteType2
  dismissedContent?: Span[]
  dismissedConditions?: DismissedConditionInfo[]
  baseNoteId?: string | null
  legacyDismissedContent?: string[] | null
  existingSpans?: Span[]
  generationTimestamp?: string | null
  generationSnapshotVersion?: string | null
  fetchTimestamp?: string | null
  userPrompt?: string | null
  noteStructurePreferences?: NoteStructurePreferences | null
  primarySpecialty?: Specialty | null
}
export type StartChatResponse = {
  chatId: string
  automaticPrompt: string
  model: string
  patientDataLengthChars: number
  patientDataLengthTokens: number
}
export type StartChatRequest = {
  encounterId: string
  encodedPatientId: string
  fetchTimestamp?: string | null
  patientId: string
  primarySpecialty?: Specialty | null
}
export type AddChatUserPromptRequest = {
  chatId: string
  patientId?: string | null
  userPrompt: string
  encounterId: string
  currentNoteContent?: string | null
  noteType?: NoteType2 | null
  promptId?: string | null
  encodedPatientId: string
  fetchTimestamp?: string | null
  primarySpecialty?: Specialty | null
  physicianEditSegments?: string[]
  dismissedConditions?: DismissedConditionInfo[]
  priorUserPromptCount?: number | null
  generateHandoffNoteTypes?: NoteType2[]
}
export type QueryIntent =
  | 'query'
  | 'note_action'
  | 'settings_update'
  | 'unknown'
export type CategorizeIntentResponse = {
  intent: QueryIntent
}
export type CategorizeIntentRequest = {
  userQuery: string
  chatId: string
}
export type MaxChatPatientDataResponse = {
  /** Full patient context for the Max Chat system prompt (``enhanced_data``). Regard diagnoses come first under ``## Regard Diagnoses:``: one ``[^n^]`` cite per condition—``{title} by Regard on {date} says:`` shape per ``automed.ai.citations.parse_citation``; quoted body is markdown ``# {title}`` plus ``- `` evidence lines (may span lines); ``id:/title:`` raw lines omitted; ``[B0]`` prefixes stripped. Then other sections as ``[^n^]`` lines. */
  patientDataText: string
  /** Citation blobs for Redis: one entry per ``[^n^]`` index (Regard dx entries may be multiline inside quotes). Matches ``automed.ai.citations.parse_citation``; Regard dx uses `` by Regard `` before `` on … says:``. Regard dx cites first; observation lines use ``{analyte} - {row}`` date-only shape where applicable. */
  maxChatCitationSourceText: string
}
export type MaxChatPatientDataRequest = {
  patientId: string
  encodedPatientId: string
  encounterId: string
  fetchTimestamp?: string | null
}
export type SendOutcome = 'created' | 'skipped' | 'failed'
export type ConditionSendResult = {
  displayName: string
  icd10Code: string
  outcome: SendOutcome
}
export type SendToProblemListResponse = {
  conditionsSent: number
  conditionsSkipped: number
  conditionsFailed: number
  results: ConditionSendResult[]
  epicExternalPatientId?: string | null
}
export type SendToProblemListRequest = {
  patientId: string
  encodedPatientId: string
  encounterId: string
  noteId: string
  noteText: string
  spans: Span[]
}
export type DateFormat2 =
  | 'MM/DD/YYYY'
  | 'MM/DD/YY'
  | 'MM/DD'
  | 'MM-DD-YYYY'
  | 'MM-DD-YY'
  | 'MM-DD'
export type MedicationNaming = 'Generic names' | 'Brand names'
export type MedicationDetails = 'Include dose and route' | 'Name only'
export type PendingLabsDisplay = 'Show' | 'Hide' | 'Show with (pending) flag'
export type UnfinalizedImagingReads =
  | 'Include'
  | 'Exclude'
  | 'Include with (preliminary) flag'
export type GlobalPreferences = {
  dateFormat: DateFormat2
  includeLeadingZeros: boolean
  medicationNaming: MedicationNaming
  medicationDetails: MedicationDetails
  pendingLabsDisplay: PendingLabsDisplay
  unfinalizedImagingReads: UnfinalizedImagingReads
}
export type EvidenceLineListStyle =
  | 'Dash only'
  | 'Space only'
  | 'Dash and space'
  | 'No prefix'
export type EvidenceLineCapitalization2 =
  | 'As written'
  | 'Capitalize first letter'
  | 'lowercase'
export type ConditionTitlePrefix2 =
  | 'None'
  | 'Hashtag (#)'
  | 'Numbered (1., 2., 3.)'
export type ConditionTitleCapitalization2 =
  | 'As written'
  | 'Title Case'
  | 'Sentence case'
  | 'UPPERCASE'
  | 'lowercase'
export type MedicationFormat = 'Single line' | 'Multi-line (one per line)'
export type NotePreferences = {
  evidenceLineListStyle: EvidenceLineListStyle
  evidenceLineCapitalization: EvidenceLineCapitalization2
  conditionTitlePrefix: ConditionTitlePrefix2
  conditionTitleBold: boolean
  conditionTitleItalic: boolean
  conditionTitleUnderline: boolean
  conditionTitleCapitalization: ConditionTitleCapitalization2
  medicationFormat: MedicationFormat
  includeLabValuesInAp: boolean
  includeVitalsInAp: boolean
  includeRiskScores: boolean
  showDatesForLabsImaging: boolean
  freeTextDirectives?: string[]
  noteStructurePreferences?: NoteStructurePreferences | null
}
export type DischargeSummaryMedicationFormat =
  | 'Name + dose + frequency'
  | 'Name + dose only'
  | 'Name only'
export type FollowUpFormat =
  | 'List with timeframes'
  | 'List with dates'
  | 'Narrative'
export type DischargeSummaryPreferences = {
  conditionTitlePrefix: ConditionTitlePrefix2
  conditionTitleBold: boolean
  conditionTitleItalic: boolean
  conditionTitleUnderline: boolean
  conditionTitleCapitalization: ConditionTitleCapitalization2
  medicationFormat: DischargeSummaryMedicationFormat
  highlightMedicationChanges: boolean
  includePendingResults: boolean
  followUpFormat: FollowUpFormat
  freeTextDirectives?: string[]
  noteStructurePreferences?: NoteStructurePreferences | null
}
export type AttestationPreferences = {
  agreementPhrasing?: string
  freeTextDirectives?: string[]
  noteStructurePreferences?: NoteStructurePreferences | null
}
export type ConsultPreferences = {
  conditionTitlePrefix: ConditionTitlePrefix2
  conditionTitleBold: boolean
  conditionTitleItalic: boolean
  conditionTitleUnderline: boolean
  conditionTitleCapitalization: ConditionTitleCapitalization2
  evidenceLineListStyle: EvidenceLineListStyle
  evidenceLineCapitalization: EvidenceLineCapitalization2
  medicationFormat: MedicationFormat
  freeTextDirectives?: string[]
  noteStructurePreferences?: NoteStructurePreferences | null
}
export type LearnedFromSource = {
  pastedAt: string
}
export type LearnedFromPreferences = {
  progressNote?: LearnedFromSource | null
  historyAndPhysical?: LearnedFromSource | null
  dischargeSummary?: LearnedFromSource | null
  attestation?: LearnedFromSource | null
  consult?: LearnedFromSource | null
  icuProgressNote?: LearnedFromSource | null
  icuHistoryAndPhysical?: LearnedFromSource | null
  hospitalCourseStandalone?: LearnedFromSource | null
  icuStepDownTransfer?: LearnedFromSource | null
  signOut?: LearnedFromSource | null
}
export type ConfigSource = 'user_settings'
export type ConfigSourcePreferences = {
  progressNote?: ConfigSource | null
  historyAndPhysical?: ConfigSource | null
  dischargeSummary?: ConfigSource | null
  attestation?: ConfigSource | null
  consult?: ConfigSource | null
  icuProgressNote?: ConfigSource | null
  icuHistoryAndPhysical?: ConfigSource | null
  hospitalCourseStandalone?: ConfigSource | null
  icuStepDownTransfer?: ConfigSource | null
  signOut?: ConfigSource | null
}
export type UserGeneralPreferences = {
  globalPreferences?: GlobalPreferences | null
  notePreferences?: NotePreferences | null
  dischargeSummaryPreferences?: DischargeSummaryPreferences | null
  historyAndPhysicalPreferences?: NotePreferences | null
  attestationPreferences?: AttestationPreferences | null
  consultPreferences?: ConsultPreferences | null
  icuHistoryAndPhysicalPreferences?: NotePreferences | null
  icuProgressNotePreferences?: NotePreferences | null
  hospitalCourseStandalonePreferences?: NotePreferences | null
  icuStepDownTransferPreferences?: NotePreferences | null
  signOutPreferences?: NotePreferences | null
  learnedFrom?: LearnedFromPreferences | null
  configSource?: ConfigSourcePreferences | null
}
export type DeriveNotePreferencesResponse = {
  noteType: NoteType2
  userGeneralPreferences: UserGeneralPreferences | null
}
export type DeriveNotePreferencesRequest = {
  noteType: NoteType2
  sourceTexts: string[]
  userId?: string | null
  existingPreferences?: UserGeneralPreferences | null
  globalPreferences?: GlobalPreferences | null
}
export type DeriveNoteStructureResponse = {
  noteType: NoteType2
  noteStructurePreferences: NoteStructurePreferences | null
}
export type DeriveNoteStructureRequest = {
  noteType: NoteType2
  noteText: string
}
export type DirectiveValidityReason =
  | 'conflict_with_general_rule'
  | 'misclassified_structure'
  | 'unsupported_capability'
  | 'needs_clarification'
  | 'conflict_with_section_rule'
  | 'governed_by_clinician_setting'
  | 'system_constraint'
export type InvalidDirective = {
  directive: string
  reason: DirectiveValidityReason
  message: string
  conflictingRule?: string | null
}
export type ValidateContentDirectivesResponse = {
  invalidDirectives: InvalidDirective[]
}
export type ValidateContentDirectivesRequest = {
  noteType: NoteType2
  noteStructurePreferences: NoteStructurePreferences
  newDirectives: string[]
}
export type InvalidOverride = {
  override: string
  reason: DirectiveValidityReason
  message: string
  conflictingRule?: string | null
}
export type ValidateAdminOverridesResponse = {
  invalidOverrides: InvalidOverride[]
}
export type ValidateAdminOverridesRequest = {
  noteType: NoteType2
  noteStructurePreferences: NoteStructurePreferences
  sectionTitle: string
  newOverrides: string[]
}
export type UserDirectiveValidityReason =
  | 'conflict_with_existing'
  | 'conflict_with_admin_rule'
  | 'settable_via_style_setting'
  | 'misclassified_structure'
  | 'unsupported_capability'
  | 'needs_clarification'
  | 'system_constraint'
export type InvalidUserDirective = {
  directive: string
  reason: UserDirectiveValidityReason
  message: string
  conflictingRule?: string | null
  styleSettingField?: string | null
}
export type ValidateUserDirectivesResponse = {
  invalidDirectives: InvalidUserDirective[]
}
export type NoteTypePreferences =
  | NotePreferences
  | DischargeSummaryPreferences
  | ConsultPreferences
  | AttestationPreferences
export type ValidateUserDirectivesRequest = {
  noteType: NoteType2
  newDirectives: string[]
  existingUserDirectives?: string[]
  globalPreferences?: GlobalPreferences | null
  noteTypePreferences?: NoteTypePreferences | null
}
export type StyleNoteTextResponse = {
  styledText: string
}
export type StyleNoteTextRequest = {
  userGeneralPreferences: UserGeneralPreferences
  noteType: NoteType2
  noteText: string
}
export type PreviewStructureResponse = {
  previewText: string
}
export type PreviewStructureRequest = {
  noteType: NoteType2
  noteText: string
  noteStructurePreferences: NoteStructurePreferences
}
export type PrevisitConditionItem = {
  module: string
  title: string
  source: 'dx' | 'lens' | 'both'
  isHcc: boolean
  hccCodes: string[]
  icd10Codes: string[]
  citationTags: string[]
  citationSources?: CitationSource[]
  confidence?: number | null
}
export type PrevisitConditionsResponse = {
  conditions: PrevisitConditionItem[]
}
export const {
  useSaveNoteMutation,
  useGetNoteMetadataQuery,
  useLazyGetNoteMetadataQuery,
  useGetLiveDxMutation,
  usePostScribeNoteMeshedMutation,
  useGetUserStyleQuery,
  useLazyGetUserStyleQuery,
  useSaveUserStyleMutation,
  useResetDemoDatabaseMutation,
  useResetDemoDatabaseForServiceMutation,
  useHealthcheckQuery,
  useLazyHealthcheckQuery,
  useUpdateNoteMutation,
  useUpdateNoteBlockMutation,
  useFilterEvidenceMutation,
  useFilterConditionsMutation,
  useConvertPractitionerNoteMutation,
  useGetNoteHistoryQuery,
  useLazyGetNoteHistoryQuery,
  useGenerateNoteMutation,
  useGenerateNoteStreamMutation,
  useMaxUpdateNoteMutation,
  useMaxUpdateNoteStreamMutation,
  useMaxGenerateFromBaseNoteMutation,
  useMaxGenerateFromBaseNoteStreamMutation,
  useStartChatMutation,
  useAddChatUserPromptMutation,
  useCategorizeIntentMutation,
  useMaxChatPatientDataMutation,
  useSendToProblemListMutation,
  useDeriveNotePreferencesMutation,
  useDeriveNoteStructureMutation,
  useValidateContentDirectivesMutation,
  useValidateAdminOverridesMutation,
  useValidateUserDirectivesMutation,
  useStyleNoteTextMutation,
  usePreviewStructureMutation,
  useGetPrevisitConditionsQuery,
  useLazyGetPrevisitConditionsQuery,
} = injectedRtkApi
